import { useState } from "react";
import { Box, Button, TextField, Typography, MenuItem, Select, FormControl, InputLabel } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { collection, addDoc, setDoc } from "firebase/firestore";
import { db } from "../services/firebase";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../services/firebase";
import SimpleBackdrop from "../components/SimpleBackdrop";
import CustomAlert from "../components/CustomAlert";
import MainHeaderComponent from "../components/HeadComp/MainHeaderComponent";

const FillApplication = () => {
    const [fullName, setfullName] = useState("");

    const [phoneNumber, setphoneNumber] = useState("");
    const [errorPhoneMesg, setErrorPhoneMesg] = useState("");

    const [boardWidth, setBoardWidth] = useState("");
    const [boardHeight, setBoardHeight] = useState("");
    const [description, setDescription] = useState("");

    const [companyName, setCompanyName] = useState("");
    const [address, setAddress] = useState("");
    const [request, setRequest] = useState("");

    const [file, setFile] = useState([]);
    const [errorFile, setErrorFile] = useState("");

    const [alertOpen, setAlertOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [screenLoading, setScreenLoading] = useState(false);
    // const [alertTimestamp, setAlertTimestamp] = useState(false);

    const navigate = useNavigate();

    const showCustomAlert = () => {
        setAlertMessage(`Your request submitted successfully. Please check your Application status by using your phone number`);
        setAlertOpen(true);
    };

    const handleCloseAlert = () => {
        setAlertOpen(false);
        navigate("/my_status");
    };

    const onPhoneHandle = (e) => {
        const phone = e.target.value;
        const numericPhone = phone.replace(/\D/g, '');
        setphoneNumber(numericPhone);
        if (numericPhone.length === 10) {
            setErrorPhoneMesg("");
        } else {
            setErrorPhoneMesg("Please enter a valid 10-digit phone number.");
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // if (file && !['image/jpeg', 'image/png', 'image/jpg'].includes(file.type)) {
        //     setErrorFile('Please upload a valid image file (JPEG, JPG, PNG).');
        //     return;
        // }

        if (file.length > 0 && file.some(f => !['image/jpeg', 'image/png', 'image/jpg'].includes(f.type))) {
            setErrorFile('Please upload only valid image files (JPEG, JPG, PNG).');
            return;
        }

        setScreenLoading(true);

        try {
            let fileURL = [];

            // // Only upload the file if it exists
            // if (file) {
            //     const fileRef = ref(storage, `msreports/${phoneNumber}/${file.name}`);
            //     await uploadBytes(fileRef, file);
            //     fileURL = await getDownloadURL(fileRef);
            // }

            // Upload each file and get its URL
            for (const fil of file) {
                const fileRef = ref(storage, `msreports/${phoneNumber}/${fil.name}`);
                await uploadBytes(fileRef, fil);
                const fileURLing = await getDownloadURL(fileRef);
                fileURL.push(fileURLing);
            }

            const unixTimestamp = Date.now();
            const formData = {
                fullName,
                phoneNumber,
                companyName,
                address,
                request,
                boardWidth,
                boardHeight,
                description,
                invoiceURL: "",
                fileURL,
                isVerified: "Not Verified",
                // fileName: file ? file.name : null,
                fileNames: file ? file.map(f => f.name) : [],
                createdAt: unixTimestamp,
            };

            const docRef = await addDoc(collection(db, "sign_board_requests"), formData);

            const updatedFormData = {
                ...formData,
                reqId: docRef.id,
            };

            await setDoc(docRef, updatedFormData, { merge: true });

            setScreenLoading(false);
            showCustomAlert();

        } catch (error) {
            setScreenLoading(false);
            console.error("Error adding document: ", error);
            alert("There was an error submitting the form. Please try again.");
        }
    };

    return (
        <Box sx={{ maxWidth: "100%", minWidth: 300, }}>
            <MainHeaderComponent />
            <Box
                sx={{ height: "10vh" }}
            ></Box>

            <form onSubmit={handleSubmit} autoComplete="off" >
                <Box sx={{ display: "flex", justifyContent: "center", }}>
                    <Box sx={{ width: { xs: "300px", md: "600px" } }}>
                        <Typography sx={{ mb: 2, mt: 4, fontWeight: "bold" }}>Fill the Application :</Typography>
                        <TextField
                            label="Full Name"
                            name="fullName"
                            variant="outlined"
                            type="text"
                            fullWidth
                            required
                            value={fullName}
                            onChange={(e) => setfullName(e.target.value)}
                            sx={{ marginBottom: 2, }}
                        />
                        <TextField
                            label="Phone Number"
                            name="phoneNumber"
                            placeholder="0000000000"
                            variant="outlined"
                            fullWidth
                            required
                            value={phoneNumber}
                            onChange={(e) => onPhoneHandle(e)}
                            inputProps={{ maxLength: 10, inputMode: 'numeric', pattern: '[0-9]*' }}
                            sx={{ marginBottom: 1 }}
                        />
                        {
                            errorPhoneMesg !== "" ?
                                <Typography sx={{ fontSize: "10px", color: "red", }}>{errorPhoneMesg}</Typography>
                                : <Box p={0.95} />
                        }
                        <TextField
                            label="Company Name / Shop Name"
                            name="companyName"
                            variant="outlined"
                            type="text"
                            fullWidth
                            required
                            value={companyName}
                            onChange={(e) => setCompanyName(e.target.value)}
                            sx={{ marginBottom: 2, mt: 1 }}
                        />
                        <TextField
                            label="Address"
                            placeholder="Address"
                            name="address"
                            variant="outlined"
                            type="text"
                            fullWidth
                            required
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                            sx={{ marginBottom: 2 }}
                        />
                        <FormControl fullWidth sx={{ marginBottom: 2 }}>
                            <InputLabel id="request-label">Request</InputLabel>
                            <Select
                                labelId="request-label"
                                value={request}
                                onChange={(e) => setRequest(e.target.value)}
                                required
                            >
                                <MenuItem value="New Signboard">New Signboard</MenuItem>
                                <MenuItem value="Partially Not Working">Partially Not Working</MenuItem>
                                <MenuItem value="Fully Not Working">Fully Not Working</MenuItem>
                            </Select>
                        </FormControl>
                        <Box sx={{ display: "flex", justifyContent: "space-between", marginBottom: 1 }}>
                            <TextField
                                label="Width"
                                name="width"
                                placeholder="0000.00"
                                variant="outlined"
                                value={boardWidth}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d*\.?\d{0,2}$/.test(value)) {
                                        setBoardWidth(value);
                                    }
                                }}
                                inputProps={{ maxLength: 7, inputMode: 'decimal', pattern: '^[0-9]*\\.?[0-9]{0,2}$' }}
                            />
                            <TextField
                                label="Height"
                                name="height"
                                placeholder="0000.00"
                                variant="outlined"
                                value={boardHeight}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d*\.?\d{0,2}$/.test(value)) {
                                        setBoardHeight(value);
                                    }
                                }}
                                inputProps={{ maxLength: 7, inputMode: 'decimal', pattern: '^[0-9]*\\.?[0-9]{0,2}$' }}
                            />
                        </Box>
                        <TextField
                            label="Description"
                            name="description"
                            placeholder="Board Should be having text like this..."
                            variant="outlined"
                            type="text"
                            fullWidth
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            sx={{ marginBottom: 2 }}
                            multiline
                            rows={4}
                        />
                        <Typography>You can upload multiple images (optional)</Typography>
                        <TextField
                            name='file'
                            variant="outlined"
                            fullWidth

                            // onChange={(event) => {
                            //     const selectedFile = event.target.files[0];
                            //     if (selectedFile && ['image/jpeg', 'image/png', 'image/jpg'].includes(selectedFile.type)) {
                            //         setFile(selectedFile);
                            //         setErrorFile("");
                            //     } else {
                            //         setFile(null);
                            //         setErrorFile('Please upload a valid image file (JPEG, JPG, PNG).');
                            //     }
                            // }}

                            onChange={(event) => {
                                const selectedFiles = Array.from(event.target.files);
                                const validFiles = selectedFiles.filter(f =>
                                    ['image/jpeg', 'image/png', 'image/jpg'].includes(f.type)
                                );

                                if (validFiles.length === selectedFiles.length) {
                                    setFile(validFiles);
                                    setErrorFile("");
                                } else {
                                    setFile([]);
                                    setErrorFile('Please upload only valid image files (JPEG, JPG, PNG).');
                                }
                            }}
                            inputProps={{ multiple: true }}

                            sx={{ marginBottom: 2 }}
                            type='file'
                            id="outlined-basic"
                            InputLabelProps={{ shrink: true }}
                        />
                        <Typography sx={{ fontSize: "10px", color: "red", marginBottom: 2 }}>{errorFile}</Typography>
                        <Button variant="contained" color="primary" type="submit" fullWidth>
                            Submit
                        </Button>
                    </Box>
                </Box>
            </form>
            <Box p={2} />
            <SimpleBackdrop open={screenLoading} />
            <CustomAlert open={alertOpen} message={alertMessage} onClose={handleCloseAlert} />
        </Box>
    );
};

export default FillApplication;